import { render, staticRenderFns } from "./oftenImg.vue?vue&type=template&id=65170fd7"
import script from "./oftenImg.vue?vue&type=script&lang=js"
export * from "./oftenImg.vue?vue&type=script&lang=js"
import style0 from "./oftenImg.vue?vue&type=style&index=0&id=65170fd7&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports